module.exports = __webpack_public_path__ + "assets/img/54c3-xx.svg";